// const prod = {
//   // check Custom domain names for API GW. route53 point to this custom domain name
//   // we get cors error when we use api.northcode.dev --- interesting
//   APIGW_USERS: "https://api.northcode.dev",
//   APIGW:  "https://api.northcode.dev",
//   WEBSOCKET:  "wss://28eko76gs2.execute-api.us-east-1.amazonaws.com/live",
//   WEBSOCKET_AMAZON_CONNECT: "wss://4ozbn89wt1.execute-api.us-east-1.amazonaws.com/live",

//   gtmConfig: {
//     containerId: process.env.REACT_APP_GTM_CONTAINER_ID,
//   },
// };

const prod = {
  // check Custom domain names for API GW. route53 point to this custom domain name
  // we get cors error when we use api.ivrbdd.co.uk --- interesting
  APIGW_USERS: "https://api.ivrbdd.co.uk",
  APIGW:  "https://api.ivrbdd.co.uk",
  WEBSOCKET:  "wss://28eko76gs2.execute-api.us-east-1.amazonaws.com/live/",
  WEBSOCKET_AMAZON_CONNECT: "wss://xxx.execute-api.us-east-1.amazonaws.com/live",

  gtmConfig: {
    containerId: process.env.REACT_APP_GTM_CONTAINER_ID,
  },
};


const dev = {
  APIGW_USERS: "https://dl3ckic742.execute-api.eu-west-1.amazonaws.com/dev",
  APIGW: "https://eudd0u2ixd.execute-api.us-east-1.amazonaws.com/dev",
  WEBSOCKET: "wss://2s313wpgia.execute-api.us-east-1.amazonaws.com/live",
  WEBSOCKET_AMAZON_CONNECT: "wss://mqe1raofgc.execute-api.us-east-1.amazonaws.com/live",

  gtmConfig: {
    containerId: process.env.REACT_APP_GTM_CONTAINER_ID,
  },
};
const config = process.env.NODE_ENV === "development" ? dev : prod;

// const config = dev;

export default config;
